import Link from "next/link";

import { useRouter } from "next/router";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { handleLinkByTypeV2 } from "@/helpers/common/handleLinkByType";
import { handleStartWithSlashInUrl, validateImgSrc } from "@/utils/global";
import { v4 as uuidv4 } from "uuid";
import NextImage from "../NextImage";
import { useClient } from "@/hooks/useClient";
import { banner_clicked_event } from "@/utils/gtm";

const MainBanners = ({
  data: fromHome,
  fromCategories = null,
  isMobile = false,
}) => {
  const { locale } = useRouter();
  const data = fromCategories
    ? fromCategories?.map((item) => ({
        ...item,
      }))
    : fromHome?.value
        ?.sort((a, b) => +a.position - +b.position)
        ?.map((item) => ({
          ...item,
          img: item[`img-${locale}`],
          title: item[`title-${locale}`],
        }));
  const { isClient } = useClient();

  return isClient && Array.isArray(data) && data?.length ? (
    <Swiper
      modules={[Pagination, Autoplay]}
      loop={data?.length > 1}
      key={locale}
      dir={locale === "en" ? "rtl" : "ltr"}
      pagination={{ clickable: true, enabled: true }}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
        // pauseOnMouseEnter: true,
      }}
      className={`banner-swiper mt-4 sm:mt-0 mx-auto ${
        fromCategories ? "w-full" : "w-11/12 sm:w-full"
      } pb-9 sm:pb-0`}
    >
      {data.map((slide) => {
        const img = isMobile
          ? slide[`mobile-img-${locale}`]
          : slide["img-" + locale];
        return (
          img && (
            <SwiperSlide key={uuidv4()}>
              <Link
                href={handleLinkByTypeV2(
                  handleStartWithSlashInUrl(slide?.url),
                  slide?.type
                )}
                onClick={() => banner_clicked_event(slide, locale)}
                className="hover:opacity-100"
              >
                <NextImage
                  width={1440}
                  height={380}
                  priority
                  quality={40}
                  src={validateImgSrc(img)}
                  className="object-contain w-full sm:h-auto"
                  alt={slide?.title}
                />
              </Link>
            </SwiperSlide>
          )
        );
      })}
    </Swiper>
  ) : null;
};

export default MainBanners;
